const surveysRoutes = [
  {
    path: "survey",
    name: "Surveys",
    redirect: {
      name: "List Surveys"
    },
    component: () =>
      import(
        /* webpackChunkName: "surveys" */ "../../views/surveys/Surveys.vue"
      ),
    children: [
      {
        path: "list",
        name: "List Surveys",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/surveys/SurveysList.vue"
          )
      },
      {
        path: "new",
        name: "New Survey",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/surveys/NewSurvey.vue"
          )
      },
      {
        path: "edit/:id",
        name: "Edit Survey",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/surveys/NewSurvey.vue"
          )
      },
      {
        path: "detail/:id",
        name: "Survey Detail",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/surveys/SurveyDetail.vue"
          )
      },
      {
        path: "terms",
        name: "Survey Terms",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/surveys/SurveyTerms.vue"
          )
      }
    ]
  }
];

export default surveysRoutes;
